module.exports = __webpack_public_path__ + "static/logo-0f8621ce5f91a68ad2cdce136287a287.png";